// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.db .kt-widget4 .kt-widget4__item {
  padding-bottom: 1rem;
  border-bottom: 1px dashed #ebedf2;
  padding-top: 1rem;
}

.db.kt-portlet__body {
  padding-top: 0
}

.kt-widget4.kt-widget4--sticky .kt-widget4__items {
  flex-grow: 0 !important;
}

.kt-widget4.kt-widget4--sticky {
  /* display: -webkit-box; */
  /* display: flex; */
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.filter-chart {
  /* background: rgb(185, 205, 245); */
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 5px;
  box-sizing: border-box;
  color: rgb(0, 0, 0);
  margin: 1px;
  opacity: 1;
  outline: none;
  display: inline;
}

.flexbuttton{
  display: flex;
    align-items: center;
    align-content: space-between;
    justify-content: space-between
}
.item-con{
  display: flex;
  gap: 5%;
}
.main-container{
  width: 100%;
  /* height: 10%; */
}
.inside-conrtainer{
    display: flex;
  justify-content: space-between;
}
.log-icon{
  display: flex;
  align-items: center;
}

.btnCon{
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
}
.user-active-container{
  overflow-x: hidden;
  overflow-y: auto;
  height: 433px;
  background: white;
  box-sizing: border-box;
}
.modified-page{
  /* background: white; */
  box-sizing: border-box;
  height: 453px;
}

.bodyOfLogin{
  box-sizing: border-box;
  background: white;
  /* overflow-x: hidden;
  overflow-y: auto; */
}
th,td{
  text-align: center !important;
  }


  .Linkable{
    cursor: pointer;
  }



  .tab{
    margin: 5px;
    padding: 6px 6px 6px 6px;
    font-size: 1.2rem;
    font-weight: 500;
    color: #434349;
    display: flex;
    align-items: center;
    background-color: #c7c6c6;
    border-radius: 4px;
}


.unactive-tab{
  margin: 5px;
  padding: 6px 6px 6px 6px;
  font-size: 1.2rem;
  font-weight: 500;
  color: #434349;
  display: flex;
  align-items: center;
  /* background-color: #c7c6c6; */
  border-radius: 4px;
}

  `, "",{"version":3,"sources":["webpack://./src/app/views/dashboard/dashboard.component.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,iCAAiC;EACjC,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EAGnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;IACX,mBAAmB;IACnB,4BAA4B;IAC5B;AACJ;AACA;EACE,aAAa;EACb,OAAO;AACT;AACA;EACE,WAAW;EACX,iBAAiB;AACnB;AACA;IACI,aAAa;EACf,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB;qBACmB;AACrB;AACA;EACE,6BAA6B;EAC7B;;;EAGA;IACE,eAAe;EACjB;;;;EAIA;IACE,WAAW;IACX,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;;AAGA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;AACpB","sourcesContent":[".db .kt-widget4 .kt-widget4__item {\r\n  padding-bottom: 1rem;\r\n  border-bottom: 1px dashed #ebedf2;\r\n  padding-top: 1rem;\r\n}\r\n\r\n.db.kt-portlet__body {\r\n  padding-top: 0\r\n}\r\n\r\n.kt-widget4.kt-widget4--sticky .kt-widget4__items {\r\n  flex-grow: 0 !important;\r\n}\r\n\r\n.kt-widget4.kt-widget4--sticky {\r\n  /* display: -webkit-box; */\r\n  /* display: flex; */\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n  flex-direction: column;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.filter-chart {\r\n  /* background: rgb(185, 205, 245); */\r\n  border: 1px solid rgba(0, 0, 0, 0.3);\r\n  border-radius: 5px;\r\n  box-sizing: border-box;\r\n  color: rgb(0, 0, 0);\r\n  margin: 1px;\r\n  opacity: 1;\r\n  outline: none;\r\n  display: inline;\r\n}\r\n\r\n.flexbuttton{\r\n  display: flex;\r\n    align-items: center;\r\n    align-content: space-between;\r\n    justify-content: space-between\r\n}\r\n.item-con{\r\n  display: flex;\r\n  gap: 5%;\r\n}\r\n.main-container{\r\n  width: 100%;\r\n  /* height: 10%; */\r\n}\r\n.inside-conrtainer{\r\n    display: flex;\r\n  justify-content: space-between;\r\n}\r\n.log-icon{\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.btnCon{\r\n  height: 34px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-top: 15px;\r\n}\r\n.user-active-container{\r\n  overflow-x: hidden;\r\n  overflow-y: auto;\r\n  height: 433px;\r\n  background: white;\r\n  box-sizing: border-box;\r\n}\r\n.modified-page{\r\n  /* background: white; */\r\n  box-sizing: border-box;\r\n  height: 453px;\r\n}\r\n\r\n.bodyOfLogin{\r\n  box-sizing: border-box;\r\n  background: white;\r\n  /* overflow-x: hidden;\r\n  overflow-y: auto; */\r\n}\r\nth,td{\r\n  text-align: center !important;\r\n  }\r\n\r\n\r\n  .Linkable{\r\n    cursor: pointer;\r\n  }\r\n\r\n\r\n\r\n  .tab{\r\n    margin: 5px;\r\n    padding: 6px 6px 6px 6px;\r\n    font-size: 1.2rem;\r\n    font-weight: 500;\r\n    color: #434349;\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: #c7c6c6;\r\n    border-radius: 4px;\r\n}\r\n\r\n\r\n.unactive-tab{\r\n  margin: 5px;\r\n  padding: 6px 6px 6px 6px;\r\n  font-size: 1.2rem;\r\n  font-weight: 500;\r\n  color: #434349;\r\n  display: flex;\r\n  align-items: center;\r\n  /* background-color: #c7c6c6; */\r\n  border-radius: 4px;\r\n}\r\n\r\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
